"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typeChecks_1 = require("./typeChecks");

function getRoundingParams(value, decimals) {
  var isNegative = value < 0;
  var powerManipulator = Math.pow(10, decimals);
  return {
    isNegative: isNegative,
    powerManipulator: powerManipulator
  };
}

function applyPowerManipulator(mathFn, value, powerManipulator) {
  return mathFn(Math.abs(value) * powerManipulator) / powerManipulator;
}

function roundNumberTo(value, decimals, direction, dontFix) {
  if (direction === void 0) {
    direction = 'AUTO';
  }

  if (dontFix === void 0) {
    dontFix = false;
  }

  var _a = getRoundingParams(value, decimals),
      isNegative = _a.isNegative,
      powerManipulator = _a.powerManipulator;

  var mathFn;

  switch (direction) {
    case 'UP':
      mathFn = Math.ceil;
      break;

    case 'DOWN':
      mathFn = Math.floor;
      break;

    case 'AUTO':
    default:
      mathFn = Math.round;
      break;
  }

  var response = applyPowerManipulator(mathFn, value, powerManipulator);

  if (isNegative) {
    response = response * -1;
  }

  if (dontFix) {
    return response;
  }

  return response.toFixed(decimals);
}
/**
 * Determines if a value is a number or not
 *
 * @export
 * @param {any} value
 * @returns {boolean}
 */


function isNumber(value) {
  return Number(value) === parseFloat(value);
}

exports.isNumber = isNumber;
/**
 * Determines if a value is a zero or empty collection
 * @export
 * @param {any} value
 * @returns {boolean}
 */

function isZeroOrEmpty(value) {
  return isNumber(value) && Number(value) === 0 || typeChecks_1.isNullOrEmpty(value);
}

exports.isZeroOrEmpty = isZeroOrEmpty;
/**
 * Rounds a value to given parameters
 * @export
 * @param {number} value
 * @param {number} decimals
 * @param {boolean} dontFix
 * @returns {number | string}
 */

function roundNumber(value, decimals, dontFix) {
  if (dontFix === void 0) {
    dontFix = false;
  }

  return roundNumberTo(value, decimals, 'AUTO', dontFix);
}

exports.roundNumber = roundNumber;
/**
 * Rounds a value up to given parameters
 * @export
 * @param {number} value
 * @param {number} decimals
 * @param {boolean} dontFix
 * @returns {number | string}
 */

function roundNumberUp(value, decimals, dontFix) {
  if (dontFix === void 0) {
    dontFix = false;
  }

  return roundNumberTo(value, decimals, 'UP', dontFix);
}

exports.roundNumberUp = roundNumberUp;
/**
 * Rounds a value down to given parameters
 * @export
 * @param {number} value
 * @param {number} decimals
 * @param {boolean} dontFix
 * @returns {number | string}
 */

function roundNumberDown(value, decimals, dontFix) {
  if (dontFix === void 0) {
    dontFix = false;
  }

  return roundNumberTo(value, decimals, 'DOWN', dontFix);
}

exports.roundNumberDown = roundNumberDown;
/**
 * Returns abbreviated versions value if it's a miilion, billion, or trillion value
 * @export
 * @param {number} value
 * @param {number} decimals
 * @param {boolean} useFullAbbreviation
 * @returns {number | string}
 */

function abbreviateNumber(value, decimals, useFullAbbreviation) {
  if (decimals === void 0) {
    decimals = 1;
  }

  if (useFullAbbreviation === void 0) {
    useFullAbbreviation = true;
  }

  var million = 1000000;
  var billion = 1000000000;
  var trillion = 1000000000000;

  if (isNaN(value) || typeChecks_1.isNullOrUndefined(value)) {
    return '-';
  }

  if (value >= trillion) {
    return roundNumber(value / trillion, decimals) + (useFullAbbreviation ? ' trillion' : 'T');
  }

  if (value >= billion) {
    return roundNumber(value / billion, decimals) + (useFullAbbreviation ? ' billion' : 'B');
  }

  if (value >= million) {
    return roundNumber(value / million, decimals) + (useFullAbbreviation ? ' million' : 'M');
  }

  return roundNumber(value, decimals);
}

exports.abbreviateNumber = abbreviateNumber;